import React from 'react';
import {Button, Modal} from "semantic-ui-react";

export default class ConfirmModal extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            isOpen: false,
            title: "",
            message: "",
            okButton: "Да",
            cancelButton: "Отмена",
            promiseResolve: null,
            promiseReject: null
        };
    }

    open(title, message, okButton, cancelButton) {
        let promise = new Promise((resolve, reject) => {
            this.setState({
                isOpen: true,
                title: title,
                message: message,
                okButton: okButton ? okButton : this.state.okButton,
                cancelButton: cancelButton ? cancelButton : this.state.cancelButton,
                promiseResolve: resolve,
                promiseReject: reject
            });
        });
        return promise;
    }

    close(result) {
        if (result) {
            this.state.promiseResolve();
        } else {
            this.state.promiseReject();
        }
        this.setState({
            isOpen: false,
            title: "",
            message: "",
            promiseResolve: null,
            promiseReject: null
        });
    }

    render() {
	    let messageStyle = {
		    whiteSpace: 'pre-line',
		    wordBreak: 'break-word'
	    };

        return <Modal
            closeIcon
            onClose={() => this.close(false)}
            open={this.state.isOpen}
            size="tiny"
        >
            <Modal.Header>
                {this.state.title}
            </Modal.Header>
            <Modal.Content className='modal__content'>
                <p style={messageStyle}>{this.state.message}</p>
            </Modal.Content>
            <Modal.Actions className='modal__actions'>
                <Button onClick={() => this.close(false)}>{this.state.cancelButton}</Button>
                <Button className='modal__actions_yes' onClick={() => this.close(true)}>{this.state.okButton}</Button>
            </Modal.Actions>
        </Modal>
    }
}


// WEBPACK FOOTER //
// ./App/modals/confirmModal.jsx